import React from 'react';
import { useTranslation } from 'react-i18next';
import { Block, OutlinedButton } from '@guryou/html-components';
import { useOnboardContext } from 'onboard/context';

const StepButtons = ({ finish, showPreviousButton = true }) => {
  const { t } = useTranslation();
  const { backActiveStep } = useOnboardContext();
  return (
    <Block lg={10} md={12} xs={12} margin={0} marginTop={6}>
      {showPreviousButton && (
        <OutlinedButton marginLeft={0} onClick={() => backActiveStep()}>
          {t('ONBOARD.prev')}
        </OutlinedButton>
      )}
      <OutlinedButton type="submit" marginLeft={0}>
        {finish ? t('ONBOARD.finish') : t('ONBOARD.next')}
      </OutlinedButton>
    </Block>
  );
};

export default StepButtons;
